<template>
  <div style="padding: 5px;">
    <Row :gutter="8" class="filter-advanced">
      <Col span="4">
        <PartCategorySelect
          :component-type="componentType"
          :categoryId.sync="formData.filters.terms['part_category_ids']"
          :aggResults="categoryFilters"
          :allowParentSelect="true"
          @change="handleChangePartCategory"></PartCategorySelect>
      </Col>
      <Col span="4">
        <Input v-model="formData.filters.matches.specification" :placeholder="$t('part.info.specification')"></Input>
      </Col>
      <Col span="4">
        <Input v-model="formData.filters.matches.mpn" :placeholder="$t('part.info.mpn')"></Input>
      </Col>
      <Col span="4">
        <Select v-model="formData.filters.terms.brand" clearable filterable :placeholder="$t('part.info.brand')">
          <Option v-for="item in brandFilters"
                  :key="'brand.' + item.key"
                  :value="item.key"
                  :label="item.key">
            {{ item.key }} <span class="search-count">{{item.doc_count}}</span>
          </Option>
        </Select>
      </Col>
      <Col span="4">
        <Input v-model="formData.filters.matches['chinese_name.raw']" :placeholder="$t('part.info.chinese_name')"/>
      </Col>
      <Col span="4">
        <Input v-model="formData.filters.matches.part_number" :placeholder="$t('part.info.part_number')"/>
      </Col>
    </Row>
    <Row :gutter="8" style="margin-top: 12px;">
      <Col span="4">
        <Select clearable placeholder="Select moderation state" v-model="formData.filters.terms.moderation_state" @on-change="handleEmit">
          <Option v-for="item in moderationStates" :key="item.value" :value="item.value">
            {{ item.label }}
            <span style="float: right; font-size: 90%">{{ item.desc }}</span>
          </Option>
        </Select>
      </Col>
      <Col span="4">
        <Select placeholder="Select lifecycle status" v-model="formData.filters.terms.lifecycle_status" clearable transfer>
          <OptionGroup :label="$t('part.info.lifecycle_status_standard')">
            <Option v-for="item in lifecycleStatus.standard" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </OptionGroup>
          <OptionGroup :label="$t('part.info.lifecycle_status_custom')">
            <Option v-for="item in lifecycleStatus.custom" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </OptionGroup>
        </Select>
      </Col>
    </Row>
    <Row :gutter="8" style="margin-top: 12px;" class="advanced-specification-filter component-spec-properties" v-show="!!specMetaFilters && specMetaFilters.length > 0">
      <Col span="3" v-if="specMetaFilters && specMetaFilters.length > 0"
            v-for="mainSpecMeta in specMetaFilters" :key="'spec.' + mainSpecMeta.key" class="spec-col">
        <Select v-model="formData.filters.specs[mainSpecMeta.key]" :placeholder="mainSpecMeta.name"
                filterable clearable
                remote
                size="small"
                :loading="loadingFacet"
                :remote-method="(q) => { handleSearchSpecValues(q, mainSpecMeta.key) }"
                @on-select="hanldeLoadSpecValues">
          <label slot="prefix" class="label-prefix">
            {{ !!mainSpecMeta.chinese_name ? mainSpecMeta.chinese_name : mainSpecMeta.name }}:
          </label>
          <Option v-if="_.get(specFacetValues, mainSpecMeta.key)"
                  v-for="(specValue, index) in _.get(specFacetValues, mainSpecMeta.key)"
                  :value="specValue.key"
                  :key=" mainSpecMeta.key + '.values.' + index"
                  :label="specValue.key">
            {{ specValue.key }} <span class="search-count">( {{specValue.doc_count}} )</span></Option>
        </Select>
      </Col>
      <Col span="2">
        <Button icon="ios-close" type="text" @click="handleResetSpecs" style="margin-right: 35px">Reset Specs</Button>
      </Col>
    </Row>
    <Row :gutter="8" style="margin-top: 12px;">
      <Col span="24" align="right">
        <Button icon="ios-search" type="primary" @click="handleSearch">Search</Button>
      </Col>
    </Row>
  </div>
</template>

<script>
import PartCategorySelect from '@/view/part/components/part-category-select'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'partSearchAdvancedFilters',
  components: {
    PartCategorySelect
  },
  props: {
    matches: {
      type: Object,
      default: () => {
        return {}
      }
    },
    exists: {
      type: Object,
      default: () => {
        return {}
      }
    },
    keyword: {
      type: String
    },
    terms: {
      type: Object,
      default: () => {
        return {}
      }
    },
    aggs: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      loadingFacet: false,
      formData: {
        filters: {
          keyword: '',
          matches: {},
          terms: {
            component_type: 'electronic-part'
          },
          specs: {},
          exists: {}
        },
        aggregations: {}
      },
      aggResults: null,
      // Filters
      specMetaAddToFilters: null,
      specMetaFilters: [],
      categoryFilters: [],
      brandFilters: [],
      category: null,
      moderationStates: [
        { value: 0, label: 'Draft', desc: 'May have problem to be referenced.' },
        { value: 1, label: 'Reviewed', desc: 'OK to be referenced.' },
        { value: -1, label: 'Invalid', desc: 'Stop using it immediately.' }
      ],
      lifecycleStatus: {
        standard: [
          { value: 'active', label: 'Active' },
          { value: 'nrnd', label: 'Not recommended for new designs (NRND)' },
          { value: 'eol', label: 'End of life (EOL)' }
        ],
        custom: [
          { value: 's0', label: 'S0 - Concept/Design' },
          { value: 's1', label: 'S1 - Prototyping (Functional testing)' },
          { value: 's2', label: 'S2 - Prototyping (Manufacturable testing)' },
          { value: 's3', label: 'S3 - NPI' },
          { value: 's4', label: 'S4 - Pilot run' },
          { value: 's5', label: 'S5 - Volume production' },
          { value: 's6', label: 'S6 - SCM' }
        ]
      },

      // Spec Values mapping
      specFacetValues: {},
      componentType: 'electronic-part'
    }
  },
  created () {
    this.initFilters()
    this.initAggs()
    this.getPartSpecMetadatas()
  },
  mounted () {
    this.handleEmit()
    this.handleRefreshAggFilters()
  },
  computed: {
    ...mapState({
      specMetadatas: state => state.part.specMetadatas
    }),
    categoryCodes: function () {
      if (this.categoryFilters && !_.isEmpty(this.categoryFilters)) {
        return _.map(this.categoryFilters, (facetValue) => {
          return facetValue.key
        })
      }
      return []
    }
  },
  watch: {
    'formData.filters': {
      handler: function () {
        this.handleEmit()
      },
      deep: true
    }
  },
  methods: {
    ...mapActions([
      'searchManufacturerPart',
      'getPartSpecMetadatas',
      'getPartCategoryById'
    ]),
    handleSearch () {
      this.handleEmit()
      this.$emit('onSearch', this.formData.filters)
    },
    // THis function will be invoked by parent comonent
    async setAggResult (aggResults) {
      // await this.setFilters()
      this.hanldeLoadSpecValues()
    },
    async setFilters (aggResults) {
      this.aggResults = aggResults
      await this.getPartSpecMetadatas()
      this.setClassNumberAggFilter(aggResults)
      this.setBrandFilter(aggResults)
      this.setSpecMetaFacetValues(aggResults)
    },
    initFilters () {
      this.$set(this.formData.filters, 'keyword', '')
      this.$set(this.formData.filters, 'matches', {})
      this.$set(this.formData.filters, 'terms', { component_type: 'electronic_part' })
      this.$set(this.formData.filters, 'specs', {})
      this.$set(this.formData.filters, 'exists', {})
      this.handleEmit()
    },
    setFilterFormValue (filters) {
      this.formData.filters = filters
      this.handleEmit()
    },
    initAggs () {
      this.$set(this.formData, 'aggregations', {
        part_category_ids: {
          terms: {
            field: 'part_category_ids',
            include: '.*.*',
            size: 1000
          }
        },
        brands: {
          terms: {
            field: 'brand',
            size: 1000
          }
        },
        spec_metas: {
          nested: {
            path: 'spec_metas'
          },
          aggs: {
            keys: {
              terms: {
                field: 'spec_metas.key',
                include: '.*.*',
                size: 22
              }
            }
          }
        }
      })
      this.handleEmit()
    },
    handleResetSpecs () {
      this.$set(this.formData.filters, 'specs', {})
      this.handleEmit()
      this.handleRefreshAggFilters()
    },
    handleEmit () {
      this.$emit('update:aggs', this.formData.aggregations)
      this.$emit('update:terms', this.formData.filters.terms)
      this.$emit('update:keyword', this.formData.filters.keyword)
      this.$emit('update:matches', this.formData.filters.matches)
      this.$emit('update:specs', this.formData.filters.specs)
      this.$emit('update:exists', this.formData.filters.exists)
    },
    handleChangeSubstitionExist () {
      this.filters.matches.substitute_components = {}
      this.handleEmit()
    },
    handleRefreshAggFilters () {
      this.loadingFacet = true
      this.searchManufacturerPart({
        keyword: this.formData.filters.keyword,
        matches: this.formData.filters.matches,
        size: 0,
        terms: this.formData.filters.terms,
        specs: this.formData.filters.specs,
        exists: this.formData.filters.exists,
        aggs: this.formData.aggregations
      }).then((res) => {
        if (res.aggs) {
          this.setFilters(res.aggs)
        }
      }).finally(() => {
        this.loadingFacet = false
      })
    },
    hanldeLoadSpecValues () {
      _.each(this.specMetaFilters, (meta) => {
        let specAgg = this.generateSpecValueFilterAggQuery(meta.key)
        this.$set(this.formData.aggregations, meta.key, specAgg)
      })
      this.handleEmit()
      this.handleRefreshAggFilters()
    },
    handleSearchSpecValues (q, specKey) {
      this.loadingFacet = true
      this.searchManufacturerPart({
        keyword: this.formData.filters.keyword,
        matches: this.formData.filters.matches,
        size: 0,
        page: 1,
        terms: this.formData.filters.terms,
        specs: this.formData.filters.specs,
        exists: this.formData.filters.exists,
        aggs: {
          spec_metas: {
            nested: {
              path: 'specs'
            },
            aggs: {
              keys: {
                filter: { term: { 'specs.key': specKey } },
                aggs: {
                  values: {
                    terms: {
                      field: 'specs.display_value',
                      include: '.*' + q + '.*'
                    }
                  }

                }
              }

            }
          }
        }
      }).then((res) => {
        let facetOptons = _.get(res.aggs, 'spec_metas.keys.values.buckets', [])
        this.setSpecMetaOptions(specKey, facetOptons)
      }).finally(() => {
        this.loadingFacet = false
      })
    },
    setClassNumberAggFilter (aggResults) {
      this.categoryFilters = _.get(aggResults, 'part_category_ids.buckets')
    },
    setBrandFilter (aggResults) {
      this.brandFilters = _.get(aggResults, 'brands.buckets')
    },
    setSpecMetaFacetValues (aggResults) {
      let res = _.get(aggResults, 'spec_metas.keys.buckets', [])
      _.each(res, (n) => {
        let facetOptons = _.get(aggResults, n.key + '.keys.values.buckets', null)
        if (facetOptons) {
          this.setSpecMetaOptions(n.key, facetOptons)
        }
      })
    },
    setSpecMetaOptions (specKey, options = []) {
      let specMeta = this.findSpecMeta(specKey)
      if (specMeta) {
        this.$set(this.specFacetValues, specMeta.key, options)
      }
    },
    findSpecMeta (key) {
      return _.clone(_.find(this.specMetadatas, (s) => {
        return s.key === key
      }))
    },
    handleChangePartCategory (category) {
      if (category) {
        this.getPartCategoryById(category.id).then(res => {
          if (res && res.main_specs) {
            this.specMetaFilters = res.main_specs
          }
        })
      }
      // Reorder and highlight
      this.hanldeLoadSpecValues()
      // if (this.aggResults) {
      //   this.setSpecMetaAggFilter(this.aggResults)
      // }
    },
    generateSpecValueFilterAggQuery (specKey, q = '') {
      return {
        'nested': {
          'path': 'specs'
        },
        'aggs': {
          'keys': {
            'filter': { 'term': { 'specs.key': specKey } },
            'aggs': {
              'values': {
                'terms': {
                  'field': 'specs.display_value',
                  'include': '.*' + q + '.*',
                  'size': 100
                }
              }
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .search-count {
    font-size: 9px;
    color: gray;
    float: right;
  }

  .spec-col {
    margin: 3px 0;
  }

  .label-prefix {
    word-break: keep-all;
    white-space: nowrap;
  }
</style>
